export const enum JUDGE_ROLES {
  JUDGE = "judge",
  CHIEF_JUDGE = "chiefJudge",
}

export const enum TV_INPUT_MODE {
  ELEMENTS = "ELEMENTS",
  ELEMENTS_2 = "ELEMENTS_2",
  DEFAULT = "DEFAULT",
}

export const enum AV_B_INPUT_MODE {
  ELEMENTS = "ELEMENTS",
  DEFAULT = "DEFAULT",
}

export const TVS = "TVS" as const;
